import type { ReactNode } from "react";
import styles from "./Badge.module.css";

type BadgeTone = "sale" | "new" | "gold" | "neutral";

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

/** Small label for sale / new / premium signals on product tiles. */
export function Badge({ children, tone = "neutral", className }: BadgeProps) {
  const cls = [styles.badge, styles[`t-${tone}`], className ?? ""]
    .filter(Boolean)
    .join(" ");
  return <span className={cls}>{children}</span>;
}
